import { createFileRoute } from '@tanstack/react-router';
import { DashboardChangelogPage } from '@pages/changelog';

/** Changelog-Route (/changelog) */
export const Route = createFileRoute('/_authenticated/changelog')({
  component: DashboardChangelogPage,
});
